import React from "react"
import GagImage from "../GagImage/GagImage";
import GagVideo from "../GagVideo/GagVideo";
import {Col, Container, Form, Row} from "react-bootstrap";
import {putPost} from "../../api/api_post";
import {deleteCategoryPost, postCategoryPost} from "../../api/api_category_post";
import {deletePostPostOption, postPostPostOption} from "../../api/api_post_post_option";

export default class EditPost extends React.Component {

    constructor(props) {
        super(props)

        const {post} = this.props

        this.state = {
            post: post
        }

        this.handleCategoriesCheckboxes = this.handleCategoriesCheckboxes.bind(this)
        this.handlePostOptionsCheckboxes = this.handlePostOptionsCheckboxes.bind(this)
        this.handleChangeTitle = this.handleChangeTitle.bind(this)
        this.handleSaveChangeTitle = this.handleSaveChangeTitle.bind(this)
        this.handlePostCheckbox = this.handlePostCheckbox.bind(this)
    }

    handleChangeTitle(e) {
        this.setState({post: {...this.state.post, title: e.target.value}})
    }

    handleSaveChangeTitle() {
        let post = {title: this.state.post.title, isEdited: true}

        if (this.state.post.title === '') {
            post.isDisplayedTitle = false
        } else {
            post.isDisplayedTitle = true
        }
        this.setState({post: {...this.state.post, isDisplayedTitle: post.isDisplayedTitle, isEdited: true}})
        putPost(this.state.post.id, post)
    }

    handlePostCheckbox(e) {
        let newStatePost = {...this.state.post}
        newStatePost[e.target.name] = e.target.checked
        this.setState({post: newStatePost})

        let updatePost = {}
        updatePost[e.target.name] = e.target.checked
        putPost(this.state.post.id, updatePost)
    }

    handleCategoriesCheckboxes(e) {
        if (e.target.checked) {
            Promise.all([postCategoryPost(e.target.dataset.categoryid, this.state.post.id)]).then((promisesResults) => {
                const [newCategoryPost] = promisesResults
                let post = {...this.state.post}
                post.categoryPosts.push(newCategoryPost)
                this.setState({post: post})
            })
        } else {
            Promise.all([deleteCategoryPost(e.target.dataset.categorypostsid)]).then((promisesResults) => {
                let post = {...this.state.post}
                post.categoryPosts = post.categoryPosts.filter(categoryPost => categoryPost.id !== parseInt(e.target.dataset.categorypostsid));
                this.setState({post: post})
            })
        }
    }

    handlePostOptionsCheckboxes(e) {
        if (e.target.checked) {
            Promise.all([postPostPostOption(this.state.post.id, e.target.dataset.postoptionid)]).then((promisesResults) => {
                const [newPostPostOption] = promisesResults
                let post = {...this.state.post}
                post.postPostOptions.push(newPostPostOption)
                this.setState({post: post})
            })
        } else {
            Promise.all([deletePostPostOption(e.target.dataset.postpostoptionid)]).then((promisesResults) => {
                let post = {...this.state.post}
                post.postPostOptions = post.postPostOptions.filter(postPostOption => postPostOption.id !== parseInt(e.target.dataset.postpostoptionid));
                this.setState({post: post})
            })
        }
    }

    render() {
        if (this.state.post === null) {
            return ""
        }

        let postCategoriesIds = []
        if (this.state.post.categoryPosts.length > 0) {
            postCategoriesIds = this.state.post.categoryPosts.map((categoryPost, index) => {
                return {
                    categoryPostsId: categoryPost.id,
                    categoryId: categoryPost.category.id
                }
            })
        }


        let categories = this.props.allCategories.map((category, index) => {
            let isCategoryChecked = false;
            let categoryPostsId = null

            for(let i = 0; i < postCategoriesIds.length; i++) {
                if (postCategoriesIds[i].categoryId === category.id) {
                    isCategoryChecked = true
                    categoryPostsId = postCategoriesIds[i].categoryPostsId
                    break;
                }
            }

            return <Form.Check
                inline
                type="checkbox"
                id={"category" + index}
                key={"category" + index}
                data-categoryid={category.id}
                data-categorypostsid={categoryPostsId}
                label={category.name}
                checked={isCategoryChecked}
                onChange={this.handleCategoriesCheckboxes}
            />
        })

        
        let postPostOptionsIds = []
        if (this.state.post.postPostOptions.length > 0) {
            postPostOptionsIds = this.state.post.postPostOptions.map((postPostOption, index) => {
                return {
                    postPostOptionId: postPostOption.id,
                    postOptionId: postPostOption.postOption.id
                }
            })
        }

        let postOptions = this.props.allPostOptions.map((postOption, index) => {
            let isPostOptionChecked = false;
            let postPostOptionsId = null

            for(let i = 0; i < postPostOptionsIds.length; i++) {
                if (postPostOptionsIds[i].postOptionId === postOption.id) {
                    isPostOptionChecked = true
                    postPostOptionsId = postPostOptionsIds[i].postPostOptionId
                    break;
                }
            }

            return <Form.Check
                inline
                type="checkbox"
                id={"post-option" + index}
                key={"post-option" + index}
                data-postoptionid={postOption.id}
                data-postpostoptionid={postPostOptionsId}
                label={postOption.name}
                checked={isPostOptionChecked}
                onChange={this.handlePostOptionsCheckboxes}
            />
        })


        let media = "Unhandled gag type : " + this.props.post.type
        if (this.props.post.type === 'image') {
            media = <GagImage gag={this.props.post}/>
        } else if (this.props.post.type === 'video') {
            media = <GagVideo gag={this.props.post}/>
        }

        return <Container>
            <Row className="justify-content-md-center ">
                <Col md="auto"><h2>Post #{this.props.post.id}</h2></Col>
            </Row>
            <Form>

                <Form.Group as={Row} className="mb-3" controlId="titleGroup">
                    <Col sm="9">
                        <Form.Control placeholder="Title" value={this.state.post.title}
                                      onChange={this.handleChangeTitle} onBlur={this.handleSaveChangeTitle}/>
                    </Col>

                    <Col sm="3">
                        <Form.Check
                            type="checkbox"
                            id="displayed-title"
                            name="isDisplayedTitle"
                            label="Display title"
                            checked={this.state.post.isDisplayedTitle}
                            onChange={this.handlePostCheckbox}
                        />
                        <Form.Check
                            type="checkbox"
                            id="post-visible"
                            name="isVisible"
                            label="Post Visible"
                            checked={this.state.post.isVisible}
                            onChange={this.handlePostCheckbox}
                        />
                        <Form.Check
                            type="checkbox"
                            id="edited"
                            name="isEdited"
                            label="Edited"
                            checked={this.state.post.isEdited}
                            onChange={this.handlePostCheckbox}
                        />
                    </Col>
                </Form.Group>

                <Col sm="12">
                    <h5>Categories</h5>
                    {categories}
                </Col>
                <Col sm="12">
                    <h5>Options</h5>
                    {postOptions}
                </Col>
            </Form>

            <Row>
                <Col>
                    <center>
                            {media}
                            <br/>
                            {this.props.post.type}/{this.props.post.mime} - {this.props.post.content}
                    </center>
                </Col>
            </Row>
        </Container>
    }
}